import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const languages = [
        { code: 'pl', label: 'PL' },
        { code: 'en', label: 'EN' },
        { code: 'de', label: 'DE' }
    ];

    const currentLang = languages.find(lang => lang.code === i18n.language) || languages[0];
    const otherLangs = languages.filter(lang => lang.code !== i18n.language);

    const changeLanguage = (code) => {
        i18n.changeLanguage(code);
        setIsOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="language-switcher" ref={dropdownRef}>
            <button
                className="lang-btn active"
                onClick={() => setIsOpen(!isOpen)}
            >
                {currentLang.label}
            </button>

            {isOpen && (
                <div className="lang-dropdown">
                    {otherLangs.map(lang => (
                        <button
                            key={lang.code}
                            className="lang-btn"
                            onClick={() => changeLanguage(lang.code)}
                        >
                            {lang.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default LanguageSwitcher;
